export function useGtmAuth() {
    const loginEvent = (customerId: number) => {
        useGtm()?.trackEvent({
            event: 'Customer Login',
            eventCategory: 'login form',
            eventAction: 'Customer login successful',
            visitorId: customerId,
            eventNonInteraction: false,
        })
    }

    const registerEvent = () => {
        useGtm()?.trackEvent({
            event: 'GAEvent',
            eventCategory: 'registration form',
            eventAction: 'registration complete',
            eventLabel: '',
            eventNonInteraction: true,
        })
    }

    const newsletterSignUpEvent = ({ email, phone }: { email?: string, phone?: string }) => {
        useGtm()?.trackEvent({
            event: 'GAEvent',
            eventCategory: 'newsletter signup',
            ...email && {
                emailAddress: email
            },
            ...phone && {
                phoneNumber: phone,
            },
        })
    }

    return {
        loginEvent,
        registerEvent,
        newsletterSignUpEvent,
    }
}
